import './HeroWithDescription.scss';

class HeroWithDescription {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['HeroWithDescription'] = HeroWithDescription;
export default HeroWithDescription;
